// https://www.figma.com/file/gvWp162SeR6NMWLoEHu8KH/Design-System?node-id=208%3A2857
const colorSets = ['bg', 'ring', 'ringOffset', 'border', 'text', 'placeholder'];
const colorSetMapping = Object.fromEntries(
  colorSets.map((setName) => [
    setName,
    {
      primary: 'hsla(210, 91%, 18%, 1)', // blue-900
      secondary: 'hsla(210, 94%, 25%, 1)', // blue-800
      tertiary: 'hsla(210, 92%, 35%, 1)', // blue-700
      highlight: 'hsla(212, 100%, 97%, 1)', // blue-100
      gray: {
        100: `hsl(0, 0%, 97%)`,
        200: `hsl(200, 4%, 85%)`,
        300: `hsl(210, 3%, 73%)`,
        400: `hsl(210, 3%, 63%)`,
        500: `hsl(207, 4%, 52%)`,
        600: `hsl(206, 3%, 43%)`,
        700: `hsl(207, 5%, 34%)`,
        800: `hsl(213, 9%, 25%)`,
        900: `hsl(216, 11%, 18%)`,
        1000: `hsl(210, 17%, 9%)`,
      },

      red: {
        100: `hsla(0, 100%, 98%, var(--tw-${setName}-opacity, 1))`,
        200: `hsla(0, 89%, 89%, var(--tw-${setName}-opacity, 1))`,
        300: `hsla(0, 86%, 80%, var(--tw-${setName}-opacity, 1))`,
        400: `hsla(0, 82%, 72%, var(--tw-${setName}-opacity, 1))`,
        500: `hsla(0, 84%, 59%, var(--tw-${setName}-opacity, 1))`,
        600: `hsla(0, 82%, 46%, var(--tw-${setName}-opacity, 1))`,
        700: `hsla(0, 87%, 36%, var(--tw-${setName}-opacity, 1))`,
        800: `hsla(0, 88%, 27%, var(--tw-${setName}-opacity, 1))`,
        900: `hsla(0, 84%, 20%, var(--tw-${setName}-opacity, 1))`,
        1000: `hsla(0, 79%, 11%, var(--tw-${setName}-opacity, 1))`,
      },

      raspberry: {
        100: `hsla(330, 100%, 98%, var(--tw-${setName}-opacity, 1))`,
        200: `hsla(330, 86%, 89%, var(--tw-${setName}-opacity, 1))`,
        300: `hsla(330, 87%, 79%, var(--tw-${setName}-opacity, 1))`,
        400: `hsla(330, 88%, 70%, var(--tw-${setName}-opacity, 1))`,
        500: `hsla(330, 78%, 57%, var(--tw-${setName}-opacity, 1))`,
        600: `hsla(330, 86%, 44%, var(--tw-${setName}-opacity, 1))`,
        700: `hsla(330, 87%, 35%, var(--tw-${setName}-opacity, 1))`,
        800: `hsla(330, 83%, 27%, var(--tw-${setName}-opacity, 1))`,
        900: `hsla(330, 81%, 19%, var(--tw-${setName}-opacity, 1))`,
        1000: `hsla(329, 75%, 11%, var(--tw-${setName}-opacity, 1))`,
      },

      violet: {
        100: `hsla(264, 100%, 98%, var(--tw-${setName}-opacity, 1))`,
        200: `hsla(271, 81%, 90%, var(--tw-${setName}-opacity, 1))`,
        300: `hsla(270, 79%, 81%, var(--tw-${setName}-opacity, 1))`,
        400: `hsla(270, 84%, 75%, var(--tw-${setName}-opacity, 1))`,
        500: `hsla(270, 84%, 66%, var(--tw-${setName}-opacity, 1))`,
        600: `hsla(271, 76%, 57%, var(--tw-${setName}-opacity, 1))`,
        700: `hsla(270, 74%, 47%, var(--tw-${setName}-opacity, 1))`,
        800: `hsla(270, 84%, 35%, var(--tw-${setName}-opacity, 1))`,
        900: `hsla(270, 86%, 25%, var(--tw-${setName}-opacity, 1))`,
        1000: `hsla(271, 83%, 14%, var(--tw-${setName}-opacity, 1))`,
      },

      purple: {
        100: `hsla(257, 54%, 97%, var(--tw-${setName}-opacity, 1))`,
        200: `hsla(254, 81%, 90%, var(--tw-${setName}-opacity, 1))`,
        300: `hsla(254, 80%, 82%, var(--tw-${setName}-opacity, 1))`,
        400: `hsla(255, 78%, 75%, var(--tw-${setName}-opacity, 1))`,
        500: `hsla(255, 80%, 67%, var(--tw-${setName}-opacity, 1))`,
        600: `hsla(255, 77%, 59%, var(--tw-${setName}-opacity, 1))`,
        700: `hsla(255, 66%, 50%, var(--tw-${setName}-opacity, 1))`,
        800: `hsla(255, 73%, 38%, var(--tw-${setName}-opacity, 1))`,
        900: `hsla(255, 71%, 27%, var(--tw-${setName}-opacity, 1))`,
        1000: `hsla(255, 61%, 14%, var(--tw-${setName}-opacity, 1))`,
      },

      indigo: {
        100: `hsla(240, 100%, 98%, var(--tw-${setName}-opacity, 1))`,
        200: `hsla(240, 100%, 92%, var(--tw-${setName}-opacity, 1))`,
        300: `hsla(240, 92%, 85%, var(--tw-${setName}-opacity, 1))`,
        400: `hsla(240, 91%, 78%, var(--tw-${setName}-opacity, 1))`,
        500: `hsla(240, 93%, 72%, var(--tw-${setName}-opacity, 1))`,
        600: `hsla(240, 89%, 66%, var(--tw-${setName}-opacity, 1))`,
        700: `hsla(240, 79%, 57%, var(--tw-${setName}-opacity, 1))`,
        800: `hsla(240, 74%, 44%, var(--tw-${setName}-opacity, 1))`,
        900: `hsla(240, 89%, 32%, var(--tw-${setName}-opacity, 1))`,
        1000: `hsla(240, 83%, 19%, var(--tw-${setName}-opacity, 1))`,
      },

      royal: {
        100: `hsla(228, 33%, 97%, var(--tw-${setName}-opacity, 1))`,
        200: `hsla(224, 77%, 88%, var(--tw-${setName}-opacity, 1))`,
        300: `hsla(224, 84%, 80%, var(--tw-${setName}-opacity, 1))`,
        400: `hsla(224, 84%, 73%, var(--tw-${setName}-opacity, 1))`,
        500: `hsla(225, 82%, 63%, var(--tw-${setName}-opacity, 1))`,
        600: `hsla(225, 75%, 55%, var(--tw-${setName}-opacity, 1))`,
        700: `hsla(225, 76%, 45%, var(--tw-${setName}-opacity, 1))`,
        800: `hsla(225, 80%, 34%, var(--tw-${setName}-opacity, 1))`,
        900: `hsla(225, 76%, 23%, var(--tw-${setName}-opacity, 1))`,
        1000: `hsla(225, 68%, 12%, var(--tw-${setName}-opacity, 1))`,
      },

      blue: {
        100: `hsla(212, 100%, 97%, var(--tw-${setName}-opacity, 1))`,
        200: `hsla(210, 81%, 85%, var(--tw-${setName}-opacity, 1))`,
        300: `hsla(210, 86%, 75%, var(--tw-${setName}-opacity, 1))`,
        400: `hsla(210, 83%, 65%, var(--tw-${setName}-opacity, 1))`,
        500: `hsla(210, 74%, 53%, var(--tw-${setName}-opacity, 1))`,
        600: `hsla(210, 94%, 43%, var(--tw-${setName}-opacity, 1))`,
        700: `hsla(210, 92%, 35%, var(--tw-${setName}-opacity, 1))`,
        800: `hsla(210, 94%, 25%, var(--tw-${setName}-opacity, 1))`,
        900: `hsla(210, 91%, 18%, var(--tw-${setName}-opacity, 1))`,
        1000: `hsla(211, 84%, 10%, var(--tw-${setName}-opacity, 1))`,
      },

      aqua: {
        100: `hsla(195, 100%, 96%, var(--tw-${setName}-opacity, 1))`,
        200: `hsla(195, 90%, 80%, var(--tw-${setName}-opacity, 1))`,
        300: `hsla(195, 85%, 63%, var(--tw-${setName}-opacity, 1))`,
        400: `hsla(195, 79%, 49%, var(--tw-${setName}-opacity, 1))`,
        500: `hsla(195, 87%, 40%, var(--tw-${setName}-opacity, 1))`,
        600: `hsla(195, 93%, 32%, var(--tw-${setName}-opacity, 1))`,
        700: `hsla(195, 90%, 26%, var(--tw-${setName}-opacity, 1))`,
        800: `hsla(196, 86%, 19%, var(--tw-${setName}-opacity, 1))`,
        900: `hsla(195, 80%, 14%, var(--tw-${setName}-opacity, 1))`,
        1000: `hsla(195, 70%, 8%, var(--tw-${setName}-opacity, 1))`,
      },

      teal: {
        100: `hsla(168, 50%, 96%, var(--tw-${setName}-opacity, 1))`,
        200: `hsla(165, 75%, 69%, var(--tw-${setName}-opacity, 1))`,
        300: `hsla(165, 82%, 45%, var(--tw-${setName}-opacity, 1))`,
        400: `hsla(165, 84%, 39%, var(--tw-${setName}-opacity, 1))`,
        500: `hsla(165, 86%, 32%, var(--tw-${setName}-opacity, 1))`,
        600: `hsla(165, 89%, 26%, var(--tw-${setName}-opacity, 1))`,
        700: `hsla(165, 90%, 20%, var(--tw-${setName}-opacity, 1))`,
        800: `hsla(165, 90%, 15%, var(--tw-${setName}-opacity, 1))`,
        900: `hsla(165, 85%, 11%, var(--tw-${setName}-opacity, 1))`,
        1000: `hsla(166, 81%, 6%, var(--tw-${setName}-opacity, 1))`,
      },

      green: {
        100: `hsla(108, 50%, 96%, var(--tw-${setName}-opacity, 1))`,
        200: `hsla(105, 73%, 74%, var(--tw-${setName}-opacity, 1))`,
        300: `hsla(105, 61%, 54%, var(--tw-${setName}-opacity, 1))`,
        400: `hsla(105, 65%, 44%, var(--tw-${setName}-opacity, 1))`,
        500: `hsla(105, 76%, 34%, var(--tw-${setName}-opacity, 1))`,
        600: `hsla(120, 84%, 27%, var(--tw-${setName}-opacity, 1))`,
        700: `hsla(120, 82%, 22%, var(--tw-${setName}-opacity, 1))`,
        800: `hsla(120, 76%, 16%, var(--tw-${setName}-opacity, 1))`,
        900: `hsla(120, 70%, 12%, var(--tw-${setName}-opacity, 1))`,
        1000: `hsla(120, 61%, 7%, var(--tw-${setName}-opacity, 1))`,
      },

      lime: {
        100: `hsla(108, 50%, 96%, var(--tw-${setName}-opacity, 1))`,
        200: `hsla(95, 75%, 68%, var(--tw-${setName}-opacity, 1))`,
        300: `hsla(95, 60%, 51%, var(--tw-${setName}-opacity, 1))`,
        400: `hsla(95, 77%, 40%, var(--tw-${setName}-opacity, 1))`,
        500: `hsla(95, 84%, 32%, var(--tw-${setName}-opacity, 1))`,
        600: `hsla(95, 85%, 26%, var(--tw-${setName}-opacity, 1))`,
        700: `hsla(95, 85%, 21%, var(--tw-${setName}-opacity, 1))`,
        800: `hsla(95, 85%, 15%, var(--tw-${setName}-opacity, 1))`,
        900: `hsla(94, 85%, 11%, var(--tw-${setName}-opacity, 1))`,
        1000: `hsla(96, 81%, 6%, var(--tw-${setName}-opacity, 1))`,
      },

      yellow: {
        100: `hsla(47, 47%, 94%, var(--tw-${setName}-opacity, 1))`,
        200: `hsla(51, 92%, 71%, var(--tw-${setName}-opacity, 1))`,
        300: `hsla(54, 86%, 46%, var(--tw-${setName}-opacity, 1))`,
        400: `hsla(54, 82%, 41%, var(--tw-${setName}-opacity, 1))`,
        500: `hsla(51, 93%, 35%, var(--tw-${setName}-opacity, 1))`,
        600: `hsla(50, 89%, 30%, var(--tw-${setName}-opacity, 1))`,
        700: `hsla(47, 88%, 24%, var(--tw-${setName}-opacity, 1))`,
        800: `hsla(43, 88%, 17%, var(--tw-${setName}-opacity, 1))`,
        900: `hsla(43, 80%, 12%, var(--tw-${setName}-opacity, 1))`,
        1000: `hsla(44, 79%, 5%, var(--tw-${setName}-opacity, 1))`,
      },

      orange: {
        100: `hsla(15, 44%, 96%, var(--tw-${setName}-opacity, 1))`,
        200: `hsla(15, 86%, 86%, var(--tw-${setName}-opacity, 1))`,
        300: `hsla(15, 86%, 74%, var(--tw-${setName}-opacity, 1))`,
        400: `hsla(15, 84%, 64%, var(--tw-${setName}-opacity, 1))`,
        500: `hsla(15, 72%, 50%, var(--tw-${setName}-opacity, 1))`,
        600: `hsla(15, 82%, 40%, var(--tw-${setName}-opacity, 1))`,
        700: `hsla(15, 81%, 33%, var(--tw-${setName}-opacity, 1))`,
        800: `hsla(15, 79%, 25%, var(--tw-${setName}-opacity, 1))`,
        900: `hsla(15, 77%, 17%, var(--tw-${setName}-opacity, 1))`,
        1000: `hsla(15, 74%, 9%, var(--tw-${setName}-opacity, 1))`,
      },
    },
  ]),
);

export const backgroundColor = colorSetMapping.bg;
export const ringColor = colorSetMapping.ring;
export const ringOffsetColor = colorSetMapping.ringOffset;
export const borderColor = colorSetMapping.border;
export const textColor = colorSetMapping.text;
export const placeholderColor = colorSetMapping.placeholder;
